<template>
  <form @submit.prevent="merge">
    <div class="box">
      <h3>Merge Users</h3>
      <hr style="margin-top: 15px" />
      <b-field label="User to merge">
        <b-autocomplete
          rounded
          v-model="userToMergeInput"
          :data="filteredUserToMerge"
          field="email"
          placeholder="e.g. ian@example.com"
          clearable
          @select="(option) => (selectedToMerge = option)"
        >
          <template #empty>No results found</template>
        </b-autocomplete>
      </b-field>
      <b-field label="User to keep">
        <b-autocomplete
          rounded
          v-model="userToKeepInput"
          :data="filteredUserToKeep"
          field="email"
          placeholder="e.g. ian2@example.com"
          clearable
          @select="(option) => (selectedToKeep = option)"
        >
          <template #empty>No results found</template>
        </b-autocomplete>
      </b-field>
      <hr />
      <button type="submit" class="button is-warning">Merge</button>
    </div>
  </form>
</template>

<script>
export default {
  props: {
    selectedToMerge: Object,
  },
  mounted() {
    fetch(route('users.basic'))
      .then((response) => response.json())
      .then((data) => {
        this.users = data;
      });
  },
  data() {
    return {
      users: [],
      userToMergeInput: this.selectedToMerge.email,
      userToKeepInput: '',
      selectedToKeep: null,
    };
  },
  methods: {
    merge() {
      this.$inertia.post(
        route('users.merge'),
        {
          userToMerge: this.selectedToMerge.unique_id,
          userToKeep: this.selectedToKeep.unique_id,
        },
        {
          onFinish: () => {
            if (Object.keys(this.$page.props.errors).length) {
              this.$buefy.toast.open({
                message: 'There was an error merging users',
                type: 'is-danger',
                position: 'is-top',
              });
            } else {
              this.$buefy.toast.open({
                message: 'User merged successfully',
                type: 'is-success',
                position: 'is-top',
              });

              this.$parent.close();
            }
          },
        }
      );
    },
  },
  computed: {
    filteredUserToMerge() {
      return this.users.filter((el) => {
        return el.email.indexOf(this.userToMergeInput) >= 0;
      });
    },
    filteredUserToKeep() {
      return this.users.filter((el) => {
        return el.email.indexOf(this.userToKeepInput) >= 0;
      });
    },
  },
};
</script>
